<template>
  <v-dialog persistent v-model="show" width="300px">
    <v-card>
      <v-card-text class="text-xs-center">
        {{ $t('app.loading') }}
        <v-progress-circular
          :size="50"
          class="mt-3 mb-3"
          color="teal"
          :value="value"
        >
          {{ value }}
        </v-progress-circular>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      count: 0,
      total: 0,
    }
  },
  computed: {
    value() {
      return parseInt((this.count * 100) / this.total)
    },
  },
  methods: {
    setTotal(t) {
      this.total = t
      this.count = 0
      this.show = true
    },
    tick() {
      this.count++
      if (this.count === this.total) {
        setTimeout(() => {
          this.show = false
        }, 1000)
      }
    },
  },
}
</script>

<style>
</style>